module.exports = __webpack_public_path__ + "static/media/canada.64b9bb7c.svg";